var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWoe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 100,
    viewBox: "0 0 86 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2011 0V20.25C54.3678 23.8333 67.7126 35.25 67.7126 52C67.7126 72.2747 51.4023 78 43 78C34.5977 78 18.2874 72.2747 18.2874 52C18.2874 35.5 31.6322 23.8333 38.7989 20.25V0C25.8659 2.66667 0 21 0 57C0 94.5 32 100 43 100C54 100 86 94.5 86 57C86 21 60.1341 2.66667 47.2011 0Z",
    fill: "#5A5145"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8161 52C58.8161 45.2 48.272 33.75 43 28.25C37.728 33.75 27.1839 45.2 27.1839 52C27.1839 60.5 33.3621 66.5 43 66.5C52.6379 66.5 58.8161 60.5 58.8161 52Z",
    fill: "#5A5145"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoe);
export default __webpack_public_path__ + "static/media/woe.dd05bde39689534d883345bc3bc4aa6b.svg";
export { ForwardRef as ReactComponent };